import { ChangeDetectionStrategy, Component, computed } from '@angular/core';

import { injectTooltipContext, NgpTooltip, NgpTooltipArrow } from 'ng-primitives/tooltip';

import { arrowCva, tooltipCva } from './tooltip.cva';
import { type TooltipContext } from './tooltip.model';

@Component({
  selector: 'ml-tooltip',
  imports: [NgpTooltipArrow],
  hostDirectives: [NgpTooltip],
  host: { '[class]': 'hostClass()' },
  template: `
    {{ ctx().content }}
    <span ngpTooltipArrow [class]="arrowClass()"></span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent {
  protected readonly ctx = injectTooltipContext<TooltipContext>();

  protected readonly hostClass = computed(() => tooltipCva({ variant: this.ctx().variant }));

  protected readonly arrowClass = computed(() => arrowCva({ variant: this.ctx().variant }));
}
